import { Box, Button, Card, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import styled from "styled-components";
import HourField from "./HourField";
import { useNavigate, useParams } from "react-router-dom";
import ModalBox from "../../../ui/ModalBox";
import { useService } from "../Provider";
import { useZone } from "../../Zones/Provider";
import { PlanEnum } from "../../../utilities/Enum";
//icons
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const Grid2 = styled.div`
  max-width: 1200px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 32px;
  row-gap: 1;
  padding-left: 20px;
  padding-top: 20px;
`;
const Grid3 = styled.div`
  max-width: 1200px;
  display: grid;
  grid-template-columns: 100px 100px 100px 100px 150px 100px 150px 100px;
  gap: 32px;
  row-gap: 1;
  padding-left: 20px;
  padding-top: 20px;
`;

const DetailHourlyService = () => {
  let theme = useTheme();
  const { zid, szid } = useParams();
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const {
    state: { selected: service },
    fetchOne: fetchService,
    remove,
  } = useService();
  const {
    state: { selected: Zone },
    fetchOne: fetchZone,
  } = useZone();

  const isSaudi = Zone?.site?.countryCode === "+966";

  const booleanValue = (val) =>
    val ? (
      <span style={{ color: "#4AA785" }}>
        <FiberManualRecordIcon
          fontSize="small"
          sx={{ fontSize: 10, mr: 0.2 }}
        />
        Active
      </span>
    ) : (
      <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
        <FiberManualRecordIcon
          fontSize="small"
          sx={{ fontSize: 10, mr: 0.2 }}
        />
        Inactive
      </span>
    );

  const getLabel = (f) => {
    if (f.label === "Zetca" && !isSaudi) return null;
    return f.label;
  };

  const getValue = (f, service) => {
    switch (f.name) {
      case "isActive":
        return booleanValue(service?.isActive);
      case "withFatoora":
        return isSaudi ? booleanValue(service?.withFatoora) : null;
      case "membershipPlanId":
        return (
          <span>
            {PlanEnum.find((p) => p.id === service?.membershipPlanId)?.name ||
              "No membership"}
          </span>
        );
      case "isETicket":
        return booleanValue(service?.isETicket);
      case "plateIsObligatory":
        return booleanValue(service?.plateIsObligatory);
      case "validationLock":
        return booleanValue(service?.validationLock);
      case "clientId":
        return <span>{service?.clientName || "No client"}</span>;
      case "runnerInRequired":
        return booleanValue(service?.runnerInRequired);
      case "runnerOutRequired":
        return booleanValue(service?.runnerOutRequired);
      default:
        return <span>{service?.[f?.name]}</span>;
    }
  };

  const pairs = (service) =>
    HourField.filter(
      (f) => !f.printDivision && !f.section2 && !f.section
    ).map((f) => {
      if (f.disable) {
        return {
          label: f.label,
          value: f.name1 ? Zone?.[f.name1]?.[f.name] : Zone?.[f.name],
        };
      }
      const label = getLabel(f);
      const value = getValue(f, service);
      return { label, value };
    });

  const section2Fields = HourField.filter((f) => f.section2);
  const printDivisions = HourField.filter((f) => f.printDivision);

  useEffect(() => {
    fetchService(szid);
  }, [szid]);

  //fetch Zones , for breadcrumb and get data when refresh
  useEffect(() => {
    fetchZone(zid);
  }, [fetchZone, zid]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleDelete = async (ID) => {
    try {
      await remove(ID);
      navigate(-1);
    } catch (error) {
      console.log(error);
    }
  };
  if (!service || !Zone) return null;

  return (
    <>
      <Typography variant="Poster" component="h4">
        Service Details
      </Typography>
      <Paper
        elevation={0}
        sx={{
          p: theme.dimensions.padding,
          pb: theme.dimensions.padding * 2,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
          background: theme.color.PaperbgColor,
          width: "95%",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="Poster" component="h4" gutterBottom>
            Service Information
          </Typography>

          <Button
            variant="contained"
            style={{ background: "#FF4747" }}
            onClick={() => setOpen(true)}
          >
            Delete
          </Button>
        </Box>
        <Grid2>
          {pairs(service).map((pair, index) => (
            <React.Fragment key={index}>
              <span style={{ color: theme.color.PaperlabelColor }}>
                {pair.label}
              </span>
              <span>{pair.value}</span>
            </React.Fragment>
          ))}
        </Grid2>
        <Grid3>
          {HourField.filter((f) => f.section2).map((f, index) => (
            <React.Fragment key={index}>
              <span style={{ color: theme.color.PaperlabelColor }}>
                {f.label}
              </span>
              <span>{service?.[f.name]}</span>
            </React.Fragment>
          ))}
        </Grid3>
        <Grid2>
          {HourField.filter((f) => f.printDivision).map((f, index) => (
            <Card
              key={index}
              sx={{
                p: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ mr: 2, color: theme.color.PaperlabelColor }}>
                {f.label}
              </Typography>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "100%",
                  backgroundColor: theme.color.PaperbgColor,
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                <Typography>{service?.[f?.name]}</Typography>
                <Typography>times</Typography>
              </div>
            </Card>
          ))}
        </Grid2>
      </Paper>
      <ModalBox
        open={open}
        operation="delete"
        handleClose={handleClose}
        handleOperation={() => {
          handleDelete(szid);
          setOpen(false);
        }}
        text={`Do you want to complete the process of deleting all information?`}
      />
    </>
  );
};

export default DetailHourlyService;